import { useTranslation } from 'react-i18next';
import { Section, Container, SectionTitle, Card } from '../../ui';
import styles from './RepriseValueProps.module.css';

interface Pillar {
  title: string;
  text: string;
}

export function RepriseValueProps() {
  const { t } = useTranslation('reprise');
  const raw = t('pillars.items', { returnObjects: true });
  const pillars: Pillar[] = Array.isArray(raw) ? (raw as Pillar[]) : [];

  return (
    <Section variant="light">
      <Container>
        <SectionTitle title={t('pillars.title')} subtitle={t('pillars.subtitle')} centered />
        <div className={styles.grid}>
          {pillars.map((pillar) => (
            <Card key={pillar.title} className={styles.card}>
              <h3 className={styles.cardTitle}>{pillar.title}</h3>
              <p className={styles.cardText}>{pillar.text}</p>
            </Card>
          ))}
        </div>
      </Container>
    </Section>
  );
}
